export var STATUS = {
  ON_RESET: "ON_RESET",
  READY: "READY",
  RESETTED: "RESETTED",
  ON_CHANGE: "ON_CHANGE",
  ON_INIT: "ON_INIT",
  ON_SUBMIT: "ON_SUBMIT",
  ON_INIT_ASYNC: "ON_INIT_ASYNC",
  ON_RUN_ASYNC: "ON_RUN_ASYNC",
  ON_ASYNC_END: "ON_ASYNC_END"
};
export var DISPATCHER_LABEL = "__$$USETHEFORM_DISPATCHER$$__";
export var FORM_VALIDATION_LABEL = "__$$USETHEFORM_VALIDATION$$__";